import { z } from 'zod';
import i18n from '../../../../../../lib/i18n';

const requiredFieldMessage = i18n.t('RequiredFieldMessage');
const invalidInformation = i18n.t('InvalidInformation');
const invalidfileExtensionMessage = i18n.t('ArquivoNaoEhCsv');

const defaultMessages = {
    invalid_type_error: invalidInformation,
    required_error: requiredFieldMessage,
};

const addCustomIssueWithoutPath = (ctx: z.RefinementCtx, message: string) => {
    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message,
    });
};

const requiredString = () => {
    return z.string(defaultMessages).min(1, requiredFieldMessage);
};

const checkFileExtension = (data: string, ctx: any) => {
    if (data.split('.').pop()?.toLowerCase() !== 'csv') {
        addCustomIssueWithoutPath(ctx, invalidfileExtensionMessage);
    }
};

const GeneralValidationSchema = z.object({
    fileName: requiredString().superRefine((data: any, ctx: any) =>
        checkFileExtension(data, ctx),
    ),
});

export default GeneralValidationSchema;
